export * from './catalog-item.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/catalog/catalog-item/index.ts